import React from 'react';
import s from './HomeCollection.module.css';

// The season chip beside "Collection" — the round's main code from the Collection read (SS2027). Nothing until it is known.
export default function HomeCollectionSeason({ season, tile = false }) {
  // on the home tile a narrow phone has no room beside "Collection" (the chip would wrap and stretch the grid row): there the season moves into the counts line
  return season ? <span className={tile ? `${s.season} ${s.tileSeason}` : s.season} data-test="home-collection-season"><i />{season}</span> : null;
}
